<form class="simple-dialog" [formGroup]="form" appFormFields>
  <div class="simple-dialog__header">
    <h2 class="simple-dialog__title">{{labels.title}}</h2>
    <div class="simple-dialog__subtitle">{{subtitle}}</div>
  </div>
  <app-form-field name="reason"></app-form-field>
  <app-form-field name="revokeLeafCertificates"></app-form-field>
  <div class="simple-dialog__actions">
    <button type="button" mat-button [mat-dialog-close] class="simple-dialog__button">
      {{labels.buttons.cancel}}
    </button>
    <button
      type="submit"
      mat-button
      [mat-dialog-close]="form.value.reason ? { ca: ca, reason: form.value.reason, revokeLeafCertificates: !!form.value.revokeLeafCertificates } : undefined"
      class="simple-dialog__button simple-dialog__button_primary"
      [disabled]="!form.valid"
    >
      {{labels.buttons.revoke}}
    </button>
  </div>
</form>
